<template>
  <div class="custom-main custom-theme">
    <a-spin :spinning="loading" :tip="loadTip">

        <a-row :gutter="32">
          <a-col :xs="24" :sm="24" :md="5" :xl="5" :xxl="5">
            <div style="display: flex;flex-direction: row;width: 100%;background-color: #2db7f5">
              <a-card  :bordered="false" size="small" style="width: 100%" :body-style="{'paddingLeft':'0px', 'paddingRight':'0px','width':'98%'}">
                <div slot="title" style="margin-left:10px; margin-top: 10px; font-size: 18px;font-family: Alibaba PuHuiTi;font-weight: 500;color: #000000;">
                  <img src="../../../assets/img/split.png" style="margin-right: 9px;user-select: none;"/>医生列表
                </div>
                <template v-if="(init.doctors||[]).length > 0">
                  <a-collapse accordion @change="collapseChange" class="schedule-collapse" :bordered="false" style="background-color: white" expandIconPosition="right">
                    <a-collapse-panel  v-for="(item, index) in init.doctors" :key="(index+1)" :header="item.name" :showArrow="false" style="background: white;margin: 8px 8px 16px 16px; border: 1px solid #E5E5E5">
                      <div v-if="currCollapse!=(index+1)" slot="extra" class="schedule-extra">展开<a-icon type="double-right" style="transform: rotate(90deg);" /></div>
                      <div v-if="currCollapse==(index+1)" slot="extra" class="schedule-extra">收起<a-icon type="double-right" style="transform: rotate(-90deg);" /></div>

                      <a-row v-for="(e, i) in item.children" :key="'d-'+(index+1)+'-'+(i+1)" border="false" :class=" null!= record && e.id==record.id ? 'schedule-row active' : 'schedule-row'" >
                        <a-col class="schedule-item" @click="loadDoctor(e.id)">
                          <span>{{ e.name }}</span>
                        </a-col>
                      </a-row>
                    </a-collapse-panel>
                  </a-collapse>
                </template>
                <template v-else>
                  <span style="line-height: 40px;color: #d02f2f;">机构当前无资质审核通过的医生.</span>
                </template>
              </a-card>
              <div style="height: calc(100vh);background-color: #F5F5F5;width: 12px"></div>
            </div>

          </a-col>
          <a-col :xs="24" :sm="24" :md="19" :xl="19" :xxl="19">
            <a-form class="custom-horizontal-form">
              <div style="margin-left:10px; margin-bottom: 10px; font-size: 20px;font-family: Alibaba PuHuiTi;font-weight: 500;color: #000000;">
                <img src="../../../assets/img/split.png" style="margin-right: 9px;user-select: none;"/>排班信息
              </div>
              <a-card :bordered="false" size="small" :body-style="{'padding' :'0px'}">

                <a-row>
                  <a-col :xs="24" :sm="8" :md="4" :lg="4" :xl="4" :xxl="4" style="border-bottom: 1px solid #e8e8e8;">
                    <a-form-item label="医生姓名" style="border-bottom: 0px; margin-bottom:0px; line-height: 37px; height: 37px;">
                      {{ record.name }}
                    </a-form-item>
                  </a-col>
                  <a-col :xs="24" :sm="8" :md="4" :lg="4" :xl="4" :xxl="4" style="border-bottom: 1px solid #e8e8e8;">
                    <a-form-item label="性别" style="border-bottom: 0px; margin-bottom:0px; line-height: 37px; height: 37px;">
                      {{ record.sexName }}
                    </a-form-item>
                  </a-col>
                  <a-col :xs="24" :sm="8" :md="6" :lg="6" :xl="6" :xxl="6" style="border-bottom: 1px solid #e8e8e8;">
                    <a-form-item label="所属科室" style="border-bottom: 0px; margin-bottom:0px; line-height: 37px; height: 37px;">
                      {{ record.departmentName }}
                    </a-form-item>
                  </a-col>
                  <a-col :xs="24" :sm="8" :md="4" :lg="4" :xl="4" :xxl="4" style="border-bottom: 1px solid #e8e8e8;">
                    <a-form-item label="职务" style="border-bottom: 0px; margin-bottom:0px; line-height: 37px; height: 37px;">
                      {{ record.job }}
                    </a-form-item>
                  </a-col>
                  <a-col :xs="24" :sm="8" :md="6" :lg="6" :xl="6" :xxl="6" style="border-bottom: 1px solid #e8e8e8;line-height: 38px; height: 38px;">&nbsp;</a-col>
                </a-row>
              </a-card>
              <a-card :bordered="false" size="small">
                <functional-calendar class="custom-cal" @changedMonth="calendarMonth" :key="markedDates[markedDatesKey]" v-model="init.calendarDates" :marked-dates="markedDates" :disabled-dates="init.disabledDates" :day-names="init.dayNames" :month-names="init.monthNames" :is-multiple="true" :calendars-count="2" :is-date-range="true" :date-format="'yyyy-mm-dd'"/>
                <a-row>
                  <a-col span="12">
                    <a-card :bordered="false" size="small" style="margin-top: 24px;">
                      <a-form :form="form" layout="horizontal">
                        <a-row>
                          <a-col :xs="9" :sm="9" :md="9" :lg="9" :xl="9">
                            <a-form-item :colon="false" label="时段间隔">
                              <a-select v-decorator="['interval', {rules: [{ required: true, message: '排班时段间隔必须选择!' }], initialValue: '30' }]" placeholder="请选择排班时段间隔" style="width: 100px;">
                                <a-select-option value="30">30分钟</a-select-option>
                                <a-select-option value="60">60分钟</a-select-option>
                              </a-select>
                            </a-form-item>
                          </a-col>
                          <a-col :xs="9" :sm="9" :md="9" :lg="9" :xl="9">
                            <a-form-item :colon="false" label="时段放号数">
                              <a-input-number :min="1" :step="1" v-decorator="['peopleNumber', {rules: [{ required: true, message: '排班每时段可预约人数必须填写!' }] }]" placeholder="请输入排班每时段可预约人数"/>
                            </a-form-item>
                          </a-col>
                          <a-col :xs="6" :sm="6" :md="6" :lg="6" :xl="6">
                            <a-button style="float: right;z-index: 99;margin-top: 4px;" @click="intervalAdd()">增加排班时段</a-button>
                          </a-col>
                        </a-row>
                        <a-row>
                          <a-col>
                            <a-table size="small" style="padding: 0px;" :columns="intervals.columns" rowKey="id" :scroll="{ x: '100%', y:200}" :pagination="false" :dataSource="intervals.data">
                              <span slot="starttime" slot-scope="text, record, index">
                                <a-form-item :colon="false" style="margin-bottom: 0px;">
                                  <a-time-picker format="HH:mm" :minute-step="30" v-decorator="[`startTime${index}`, { rules: [{ required: true, message: '班次开始时间必须选择!' }], initialValue: ((null != record.startTime && '' != record.startTime)?moment(record.startTime, 'HH:mm'):'') }]" placeholder="请选择班次开始时间"/>
                                </a-form-item>
                              </span>
                              <span slot="endtime" slot-scope="text, record, index">
                                <a-form-item :colon="false" style="margin-bottom: 0px;">
                                  <a-time-picker format="HH:mm" :minute-step="30" v-decorator="[`endTime${index}`, { rules: [{ required: true, message: '班次结束时间必须选择!' }], initialValue: ((null != record.endTime && '' != record.endTime)?moment(record.endTime, 'HH:mm'):'') }]" placeholder="请选择班次结束时间"/>
                                </a-form-item>
                              </span>
                              <span slot="ioperate" slot-scope="text, record, index">
                                <a href="javascript:;" :disabled="intervals.deleteIndex != index" @click="()=>deleteInterval(index)">删除</a>
                              </span>
                            </a-table>
                          </a-col>
                        </a-row>
                      </a-form>
                      <div class="button-container" style="float:right;margin-right: 48px;">
                        <div>
                          <a-button type="primary" style="margin-left: 24px;" @click="schedule">保存排班</a-button>
                        </div>
                      </div>
                    </a-card>
                  </a-col>
                  <a-col span="12">

                  </a-col>
                </a-row>
              </a-card>
              <a-row>
                <a-col span="24" style="text-align: center;font-family: AlibabaPuHuiTi-Medium; font-weight: bold; font-size: 14px;">
                  排班说明
                </a-col>
              </a-row>
              <a-row>
                <a-col :xs="1" :sm="1" :md="1" :lg="5" :xl="5" :xxl="5"></a-col>
                <a-col :xs="22" :sm="22" :md="22" :lg="14" :xl="14" :xxl="14" style="color: #B6BFCA;font-size: 11px;margin-top: 10px;">
                  <span>
                    1、点击日历选择时间段，首次点击为开始日期，再次点击为结束日期。（需要单独选择一天的点击两次该日期）<br>
                    2、保存排班时选择开始时间和结束时间，以时段间隔为单位，设置每段时间内的放号数
                  </span>
                </a-col>
                <a-col :xs="1" :sm="1" :md="1" :lg="5" :xl="5" :xxl="5" ></a-col>
              </a-row>
            </a-form>
          </a-col>
        </a-row>

    </a-spin>
  </div>
</template>

<script>
import moment from 'moment';
import { FunctionalCalendar } from 'vue-functional-calendar';
export default {
  name: "Schedule",
  components:{
    FunctionalCalendar
  },
  data(){
    return {
      current:{},
      loading:false,
      loadTip:'正在保存排班信息....',
      form: this.$form.createForm(this),
      currCollapse:'',    //当前选中科室
      markedDates:[],
      markedDatesKey:0,
      init:{
        startDate:'',
        endDate:'',
        dayNames: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
        monthNames: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', ' 十二月'],
        disabledDates:['beforeToday'],
        calendarDates:{},
        doctors:[]
      },
      intervals:{
        deleteIndex:0,
        columns: columns,
        data:[{id:0, startTime:'', endTime:''}]
      },
      record:{}
    }
  },
  beforeCreate() {
    let data = [{
      text: "首页",
      path: ""
    },{
      text: "医院管理",
      path: ""
    },{
      text: "排班管理",
      path: ""
    }];
    this.$store.commit('updateBreadcrumb', data);
  },
  mounted() {
    const self = this;
    this.current = JSON.parse(localStorage.getItem("curruser"));

    console.info(this.current)

    this.init.startDate = this.getCurrentMonthStartDate();
    this.init.endDate = this.getNextMonthEndDate(new Date());

    //this.current = localStorage.getItem('curruser');

    this.$axios.get('/api/clinic/doctor/trees', {params:{organId: this.current.organId, business:'OUTPATIENT'}}).then(function (res) {
      if(res.msg.flag == 0){
        if(null == res.biz || res.biz.length <= 0){
          self.$message.error({content: '诊所未注册医师，当前不能设置排班.', duration: 2});
        }else{
          self.init.doctors = res.biz;
        }
      }else{
        self.$message.error({content: res.msg.message, duration: 2});
      }
    },function(res){
    });
  },
  methods: {
    moment,
    intervalAdd:function(){
      let index = this.intervals.data.length;
      this.intervals.data.push({id:index, startTime:'', endTime:''});
      this.intervals.deleteIndex = index;
    },
    deleteInterval:function(index){
      if(index >= 1){
        let datas = new Array();
        Object.assign(datas, this.intervals.data);
        datas.splice(index, 1);

        Object.assign(this.intervals, {data: datas});
        this.intervals.deleteIndex = datas.length -1;
      }
    },
    calendarMonth:function (e) {
      this.markedDatesKey++;
      this.init.startDate = this.formatDate(new Date(e));
      this.init.endDate = this.getNextMonthEndDate(new Date(e));

      if(undefined == this.record || null == this.record ||
          undefined == this.record.id || null == this.record.id || '' == this.record.id){
        return;
      }
      this.loadSchedule(this.record.id);
    },

    loadSchedule:function (organId, id){
      const self = this;
      self.markedDates=[];
      self.markedDatesKey=0;
      this.$axios.get('/api/clinic/schedule/'+organId+'/doctor/'+id,
          {params:{startDate:this.init.startDate, business:'OUTPATIENT', endDate:this.init.endDate}}).then(function (res) {
        if(res.msg.flag == 0 && null != res.biz && res.biz.length > 0){
          res.biz.forEach(function (e, i) {
            self.markedDates.push({date:e, class:'vfc-today'});
          });
        }
      },function(res){
      });
    },
    schedule:function (){
      const self = this;
      if(undefined == this.record || null == this.record ||
          undefined == this.record.id || null == this.record.id || '' == this.record.id){
        this.$message.info({content: '请先选择需排班的医师.', duration: 2});
        return;
      }
      if(!(undefined != this.init.calendarDates && null != this.init.calendarDates
          && undefined != this.init.calendarDates.dateRange && null != this.init.calendarDates.dateRange
          && undefined != this.init.calendarDates.dateRange.start && null !=  this.init.calendarDates.dateRange.start
          && '' != this.init.calendarDates.dateRange.start && undefined != this.init.calendarDates.dateRange.end
          && null !=  this.init.calendarDates.dateRange.end && '' != this.init.calendarDates.dateRange.end)){
        this.$message.info({content: '请先选择需排班的时间段.', duration: 2});
        return;
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          self.loadTip = '正在保存排班信息....';
          self.loading = true;

          let intervals=[], startTime = '', endTime = '';
          self.intervals.data.forEach(function (item, index) {
            if(undefined != values['startTime'+index] && null != values['startTime'+index]){
              startTime = self.formatHourMinute(new Date(values['startTime'+index]));
            }
            if(undefined != values['endTime'+index] && null != values['endTime'+index]){
              endTime = self.formatHourMinute(new Date(values['endTime'+index]));
            }
            intervals.push({startTime : startTime, endTime : endTime});
          });

          let params = {organId : self.record.organId, doctorId : self.record.id, startDate:self.formatDate(new Date(self.init.calendarDates.dateRange.start)),
            endDate:self.formatDate(new Date(self.init.calendarDates.dateRange.end)), interval:values.interval,
            peopleNumber:values.peopleNumber, business:'OUTPATIENT', intervals : intervals};

          self.$axios.post('/api/clinic/schedule/batch/setting', params).then(function(res){
            self.loading=false;
            if(res.msg.flag == 0){
              self.$message.success({content: '医师排班成功.', duration: 2});
              self.loadSchedule(self.record.id);
              self.init.calendarDates={};
            }else{
              self.$message.error({content: res.msg.message, duration: 2});
            }
          },function(res){
            self.loading=false;
          });
        }
      });
    },
    loadDoctor:function (id) {
      const self = this;
      let organId = this.current.organId;
      this.loadTip = '正在获取医生排班信息....';
      this.loading = true;
      this.$axios.get('/api/clinic/'+organId+'/doctor/'+id).then(function (res) {
        self.loading = false;
        if(res.msg.flag == 0 && null != res.biz){
          self.record = res.biz;
          self.loadSchedule(organId, id);
        }else{
          self.$message.error({content: res.msg.message, duration: 2});
        }
      },function(res){
        self.loading = false;
      });
    },

    collapseChange:function (e) {
      this.currCollapse = e||'';
    }
  }
}
const columns = [
  {
    title: '开始时间',
    dataIndex: 'startTime',
    key: 'startTime',
    scopedSlots: { customRender: 'starttime' }
  },
  {
    title: '结束时间',
    dataIndex: 'endTime',
    key: 'endTime',
    scopedSlots: { customRender: 'endtime' }
  },
  {
    title: '操作',
    key: 'id',
    align: 'center',
    width: 100,
    scopedSlots: { customRender: 'ioperate' }
  }
];

</script>

<style>
  .ant-card-head{
    border-bottom: 0px!important;
  }
  .schedule-collapse .ant-collapse-header{
    padding-left: 0px;
    padding-right: 0px;
  }
  .schedule-collapse .ant-collapse-content-box{
    padding: 0px!important;
  }
  .schedule-collapse .ant-collapse-borderless > .ant-collapse-item {
    border-bottom:none!important;
  }
  .schedule-collapse .schedule-item{
    height:36px;line-height:36px;
  }

  .schedule-collapse .schedule-row{
    padding-left:12px;
    padding-right:12px;
    font-size: 14px;
    cursor: pointer;
  }

  .schedule-collapse .schedule-extra{
    color: #328AC7;
  }

  .schedule-collapse .schedule-item .schedule-doctor{
    padding: 2px 8px;
    border-radius: 4px;
  }

  .schedule-collapse .active{
    background-color: #E0EBF4!important;
  }

  .custom-cal .vfc-main-container{
    box-shadow: 0px 0px 0px 0px!important;
    border: 1px solid #E5E5E5!important;
  }

  span.vfc-span-day{
    width: 48px!important;
    line-height: 48px!important;
  }
</style>
